const disputeClaimsEN = {
    "view": {
        "table": {
            "title": "Your Copyright Infringements",
            "columns": {
                "release": "Release",
                "user": "User",
                "store": "Store",
                "claimantName": "Claimant Name",
                "claimantEmail": "Claimant Email",
                "resolutionTime": "Resolution Time",
                "remainingTime": "Remaining Time",
                "status": "Status",
            },
            "label": {
                "status_created": "Created",
                "status_pending": "Pending",
                "status_in_progress": "In Progress",
                "status_resolved": "Resolved",
                "status_copyright_violation": "Copyright Violation",
            },
            "button": {
                "exportCSV": "Export CSV"
            },
            "placeholder": {
                "search": "Search..."
            }
        }
    }
};

export default disputeClaimsEN;